/* eslint-disable react/jsx-props-no-spreading */
import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'wouter';

import useOpenedState from '../../../hooks/useOpenedState';
import * as AppPropTypes from '../../../lib/PropTypes';

import { useTheme, useThemeClassName } from '../../../contexts/ThemeContext';
import HeaderDefault from '../../partials/HeaderDefault';
import OtherLocales from '../../partials/OtherLocales';
import FooterNHL from './Footer';

import styles from '../../../../styles/partials/header-nhl.module.scss';

const propTypes = {
    className: PropTypes.string,
    pageUrls: AppPropTypes.pageUrls,
    footerMenuItems: AppPropTypes.menuItems,
};

const defaultProps = {
    className: null,
    pageUrls: null,
    footerMenuItems: null,
};

function HeaderNHL({ className, pageUrls, footerMenuItems, ...props }) {
    const openedState = useOpenedState();
    const user = useUser();
    const hasUser = user !== null;
    const { closeMenu } = openedState;
    const { header } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { theme = null } = header || {};
    const [pathname] = useLocation();
    const isHome = pathname === '/' || pathname.match(/^\/(fr|en)\/?$/) !== null;

    return (
        <HeaderDefault
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isBar]: !isHome || hasUser,
                },
                themeClassName,
                styles[theme],
                className,
            ])}
            innerClassName={styles.inner}
            fixedContentClassName={styles.fixedContent}
            logoButtonClassName={styles.logoButton}
            togglerClassName={styles.toggler}
            toggleContentClassName={styles.toggleContent}
            togglerOpenedClassName={styles.togglerOpened}
            itemsClassName={styles.items}
            itemClassName={styles.item}
            openedState={openedState}
            withoutOtherLocales
            menuChildren={
                <>
                    <div className={styles.content}>
                        <OtherLocales
                            className={styles.otherLocales}
                            linkClassName={styles.otherLocale}
                            pageUrls={pageUrls}
                        />
                    </div>
                    <FooterNHL
                        className={styles.footer}
                        menuClassName={styles.footerMenu}
                        menuItemsClassName={styles.footerMenuItems}
                        itemActiveClassName={styles.footerMenuItemActive}
                        menuItems={footerMenuItems}
                        onMenuItemClick={closeMenu}
                        withoutLegal
                    />
                </>
            }
            {...props}
        />
    );
}

HeaderNHL.propTypes = propTypes;
HeaderNHL.defaultProps = defaultProps;

export default HeaderNHL;
